import React from 'react';
import { X, CheckCircle, ArrowRight } from 'lucide-react';

const ServiceModal = ({ service, isOpen, onClose }) => {
  if (!isOpen || !service) return null;

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '1rem'
      }}
      onClick={onClose}
    >
      <div 
        style={{
          backgroundColor: 'var(--bg-card)',
          borderRadius: '1rem',
          padding: '2rem',
          maxWidth: '600px',
          width: '100%',
          maxHeight: '80vh',
          overflowY: 'auto',
          position: 'relative',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.2)',
          border: '1px solid var(--border-light)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--text-muted)',
            padding: '0.5rem',
            borderRadius: '50%',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'var(--bg-section)';
            e.target.style.color = 'var(--text-primary)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.color = 'var(--text-muted)';
          }}
        >
          <X size={20} />
        </button>

        {/* Modal Content */}
        <div>
          <div className="mb-4">
            <h2 className="heading-1 mb-2" style={{ color: 'var(--primary-brown)' }}>
              {service.detailedContent.title}
            </h2>
            <p className="body-large text-muted" style={{ whiteSpace: 'pre-line' }}>
              {service.detailedContent.subtitle}
            </p>
          </div>

          <div className="mb-6">
            <h3 className="heading-3 mb-4" style={{ fontSize: '1.125rem' }}>Points clés</h3>
            <div className="space-y-3">
              {service.detailedContent.points.map((point, index) => (
                <div 
                  key={index}
                  className="flex"
                  style={{ 
                    alignItems: 'flex-start', 
                    gap: '0.75rem',
                    padding: '0.75rem',
                    borderRadius: '0.5rem',
                    backgroundColor: index % 2 === 0 ? 'var(--bg-page)' : 'rgba(172, 153, 105, 0.05)',
                    transition: 'all 0.2s ease'
                  }}
                >
                  <CheckCircle 
                    size={20} 
                    style={{ 
                      color: 'var(--primary-gold)', 
                      flexShrink: 0,
                      marginTop: '0.125rem'
                    }} 
                    fill="var(--primary-gold)"
                  />
                  <span className="body-medium" style={{ flex: 1 }}>
                    {point}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="text-center">
            <a 
              href="https://calendly.com/arthur-vacogne-rdv/rdv-echange-1er-prise-de-contact"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              style={{ 
                width: '100%',
                fontSize: '1rem',
                fontWeight: '600'
              }}
            >
              Prendre rendez-vous
              <ArrowRight size={16} />
            </a>
            <p className="body-small text-muted mt-2">
              Premier entretien gratuit et sans engagement
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceModal;